import { Router } from "vue-router";

export default function (router: Router) {
  router.beforeResolve((to) => {
    const oauthRegex = /#access_token=.+/;
    const oauthHash = to.hash.match(oauthRegex)?.at(0);

    if (oauthHash) {
      return {
        ...to,
        hash: to.hash.replace(oauthRegex, ""),
      };
    }
  });
}
